import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import UserSelection from './components/UserSelection';
import CalendarView from './components/CalendarView';
import DailyView from './components/DailyView';
import './index.css';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Routes>
          <Route path="/" element={<UserSelection />} />
          <Route path="/calendar/:user" element={<CalendarView />} />
          <Route path="/daily/:user/:date" element={<DailyView />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
